"use client";

import type { Map as MapboxMap } from "mapbox-gl";
import { createContext, useContext } from "react";

interface MapContextValue {
  map: MapboxMap | null;
}

export const MapContext = createContext<MapContextValue | null>(null);

export function useMap(): MapContextValue {
  const context = useContext(MapContext);
  if (!context) {
    throw new Error("useMap must be used within a MapProvider");
  }
  return context;
}
